import { ShortcutContext } from "@/providers/shortcut-provider"
import { useContext } from "react"

export const useShortcutContext = () => {
	const context = useContext(ShortcutContext)
	if (!context)
		throw new Error("useShortcutContext must be used within ShortcutProvider")
	return context
}
